import { OnboardingStepType, OrganizationDetailFragment } from '@alice-financial/alice-sdk'
import { getStep } from '../utils/onboardingWorkflowUtils'

/**
 * Get step status for stepper display
 */
export const getStepStatus = (
  stepType: OnboardingStepType,
  org: OrganizationDetailFragment | null | undefined
): { completed: boolean; error: boolean; inProgress: boolean } => {
  const step = getStep(org?.onboardingWorkflow, stepType)
  const completed = step?.status === 'COMPLETED'
  const error = step?.status === 'BLOCKED'
  const inProgress = step?.status === 'IN_PROGRESS'

  return {
    completed,
    error,
    inProgress,
  }
}
